{
  "0_ALREADY_EXISTS": "\"{0}\" υπάρχει ήδη.",
  "0_OF_1": "{0} από {1}",
  "ACCOUNT_ID": "Αναγνωριστικό Λογαριασμού",
  "ADD": "Προσθήκη",
  "ADD_REMOVE_FIELDS": "Προσθήκη/αφαίρεση πεδίων",
  "AN_ERROR_OCCURED": "Παρουσιάστηκε σφάλμα",
  "APPLY": "Εφαρμογή",
  "APPLY_CHANGES": "Εφαρμογή αλλαγών",
  "ATTACH": "Επισύναψη",
  "ATTACH_AS_LINK": "Επισύναψη ως σύνδεσμος",
  "ATTACHING": "Επισύναψη...",
  "AUTOMATICALLY_RENAME": "Αυτόματη μετονομασία",
  "BACK": "Πίσω",
  "BROWSE": "Περιήγηση",
  "CANCEL": "Ακύρωση",
  "CHARACTER_COUNT": "Αριθμός χαρακτήρων:",
  "CLOSE": "Κλείσιμο",
  "CLOUD": "Cloud",
  "COMMENT": "Σχόλιο",
  "CONFIGURE_REPOSITORY_SETTINGS": "Διαμόρφωση Ρυθμίσεων Αποθετηρίου",
  "COULD_NOT_SAVE_0": "Αδυναμία αποθήκευσης \"{0}\".",
  "COULD_NOT_SAVE_0_FILE_TYPE_NOT_SUPPORTED": "Αδυναμία αποθήκευσης του \"{0}\". Ο τύπος αρχείου δεν υποστηρίζεται.",
  "DATA": "Δεδομένα",
  "DATE": "Ημερομηνία",
  "DATE_FIELDS_MUST_BE_IN_FORMAT_0": "Τα πεδία ημερομηνίας πρέπει να είναι στη μορφή {0}.",
  "DATE_PROVIDED_IS_INVALID": "Η παρεχόμενη ημερομηνία είναι άκυρη.",
  "DATE_TIME": "Ημερομηνία/Ώρα",
  "DATE_TIME_FIELDS_MUST_BE_IN_FORMAT_0": "Τα πεδία ημερομηνίας/ώρας πρέπει να είναι στη μορφή {0}.",
  "DEFAULT_FOLDER": "<Προεπιλεγμένος Φάκελος>",
  "DETAILS": "Λεπτομέρειες",
  "DO_YOU_WANT_TO_APPLY_YOUR_FIELD_CHANGES": "Θέλετε να εφαρμόσετε τις αλλαγές στα πεδία σας;",
  "DOCUMENT_NAME_IS_EMPTY": "Το όνομα εγγράφου είναι κενό",
  "DRAG_DROP_FILE": "Σύρετε και αποθέστε το αρχείο",
  "ENTRY_0_ALREADY_EXISTS_SELECT_DIFFERENT_NAME": "Μια καταχώριση με το όνομα '{0}' υπάρχει ήδη σε αυτόν τον φάκελο. Παρακαλώ επιλέξτε διαφορετικό όνομα.",
  "ENTRY_ID": "Αναγνωριστικό Καταχώρισης",
  "ENTRY_NAME": "Όνομα Εγγραφής",
  "ENTRY_NOT_FOUND": "Η εγγραφή δεν βρέθηκε.",
  "ERROR_DOWNLOADING_DOCUMENT": "Σφάλμα κατά τη λήψη εγγράφου.",
  "ERROR_OCCURRED_WHILE_CONNECTING_TO_SERVER": "Παρουσιάστηκε σφάλμα κατά τη σύνδεση με τον διακομιστή.",
  "ERROR_SAVING": "Σφάλμα κατά την αποθήκευση:",
  "FAILED_TO_OPEN_FOLDER": "Αποτυχία ανοίγματος φακέλου",
  "FAILED_TO_SAVE_COLON": "Αποτυχία αποθήκευσης:",
  "FAILED_TO_SAVE_PERIOD": "Αποτυχία αποθήκευσης.",
  "FEEDBACK": "Ανατροφοδότηση",
  "FIELDS": "Πεδία",
  "FILE_EXCEEDS_MAXIMUM_FILE_SIZE_25MB": "Αυτό το αρχείο υπερβαίνει το μέγιστο μέγεθος αρχείου των 25MB.",
  "FILE_EXTENSION": "Επέκταση Αρχείου",
  "FILE_LOCKED": "Το αρχείο είναι κλειδωμένο.",
  "FILE_MODIFIED": "Το αρχείο τροποποιήθηκε",
  "FILE_NAME": "Όνομα Αρχείου",
  "FILENAMES_CANNOT_CONTAIN_BACKSLASH": "Τα ονόματα αρχείων δεν μπορούν να περιέχουν ανάποδη κάθετο",
  "FOLDER": "Φάκελος",
  "INTEGER": "Ακέραιος",
  "LIST": "Λίστα",
  "LOADING": "Φόρτωση...",
  "LONG_FIELDS_MUST_BE_INTEGERS_BETWEEN_0_3999999999": "Τα μακρά πεδία πρέπει να είναι ακέραιοι μεταξύ 0 και 3.999.999.999",
  "LONG_INTEGER": "Μακρύς Ακέραιος",
  "NAME": "Όνομα",
  "NAME_CONFLICT": "Σύγκρουση Ονόματος",
  "NEED_HELP_SIGNING_IN_CONTACT_LASERFICHE_ADMINISTRATOR_FOR_HELP": "Χρειάζεστε βοήθεια για την είσοδο; Επικοινωνήστε με τον Διαχειριστή Laserfiche για βοήθεια.",
  "NEW_FOLDER": "Νέος Φάκελος",
  "NO": "Όχι",
  "NO_ADDITIONAL_FIELDS_ASSIGNED": "Δεν έχουν ανατεθεί επιπλέον πεδία",
  "NO_FOLDER_SELECTED": "Δεν έχει επιλεγεί φάκελος.",
  "NO_MATCHING_ENTRIES_FOUND": "Δεν βρέθηκαν αντίστοιχες εγγραφές",
  "NO_MATCHING_FIELDS_FOUND": "Δεν βρέθηκαν αντίστοιχα πεδία.",
  "NO_TEMPLATE_ASSIGNED": "Δεν έχει ανατεθεί πρότυπο",
  "NOT_AVAILABLE_WITH_TOKENS": "Δεν είναι διαθέσιμο με tokens",
  "NUMBER": "Αριθμός",
  "NUMBER_FIELD_MUST_BE_VALID_NUMBER": "Το πεδίο αριθμού πρέπει να είναι έγκυρος αριθμός",
  "OK": "Εντάξει",
  "ONE_OR_MORE_FIELDS_INVALID": "Ένα ή περισσότερα πεδία είναι άκυρα.",
  "OPEN": "Άνοιγμα",
  "OPEN_IN_LASERFICHE": "Άνοιγμα στο Laserfiche",
  "OPTIONAL": "Προαιρετικό",
  "OR": "ή",
  "PARENT_FIELD": "Γονικό Πεδίο",
  "PARENT_ID": "Αναγνωριστικό Γονέα",
  "PARENT_NAME": "Όνομα Γονέα",
  "PLEASE_SELECT_A_FOLDER": "Παρακαλώ επιλέξτε έναν φάκελο",
  "REASON_FOR_DOWNLOADING": "Λόγος Λήψης",
  "REFRESH": "Ανανέωση",
  "REMOVE": "Αφαίρεση",
  "REMOVE_REPOSITORY": "Αφαίρεση Αποθετηρίου;",
  "REPOSITORY": "Αποθετήριο",
  "REPOSITORY_COUNT": "Πλήθος Αποθετηρίου",
  "REPOSITORY_ID": "Αναγνωριστικό Αποθετηρίου",
  "REPOSITORY_NAME": "Όνομα Αποθετηρίου",
  "REQUIRED": "Απαιτείται",
  "REQUIRED_FIELD_IS_EMPTY": "Απαιτούμενο πεδίο είναι κενό",
  "SAVE_CHANGES": "Αποθήκευση Αλλαγών",
  "SAVE_TO_LASERFICHE": "Αποθήκευση στο Laserfiche",
  "SAVED_TO_LASERFICHE": "Αποθηκεύτηκε στο Laserfiche",
  "SAVED_TO_LASERFICHE_COLON": "Αποθηκεύτηκε στο Laserfiche:",
  "SAVED_WITH_MISSING_METADATA": "Αποθηκεύτηκε με ελλιπή μεταδεδομένα:",
  "SAVING": "Αποθήκευση...",
  "SEARCH_FIELDS": "Πεδία αναζήτησης",
  "SELECT": "Επιλογή",
  "SELECT_REASON": "Επιλέξτε έναν λόγο",
  "SELF_HOSTED": "Αυτο-φιλοξενούμενο",
  "SESSION_COUNT": "Αριθμός Συνεδριών",
  "SETTINGS": "Ρυθμίσεις",
  "SHORT_FIELDS_MUST_BE_INTEGERS_BETWEEN_0_64999": "Τα πεδία τύπου short πρέπει να είναι ακέραιοι μεταξύ 0 και 64999",
  "SIGN_IN": "Σύνδεση",
  "SIGN_IN_TO_LASERFICHE": "Σύνδεση στο Laserfiche",
  "SIGN_OUT": "Αποσύνδεση",
  "SIGNING_IN": "Σύνδεση...",
  "SIGNING_OUT": "Αποσύνδεση...",
  "SKIP_THIS_FILE": "Παράλειψη αυτού του αρχείου",
  "SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER": "Κάτι πήγε στραβά. Παρακαλώ δοκιμάστε ξανά αργότερα.",
  "SUBMIT": "Υποβολή",
  "SUGGESTION": "Πρόταση",
  "TEMPLATE": "Πρότυπο",
  "TEMPLATE_HAS_FAILED_TO_LOAD": "Το πρότυπο απέτυχε να φορτωθεί.",
  "TEXT": "Κείμενο",
  "THANK_YOU_FOR_SUBMISSION": "Ευχαριστούμε για την υποβολή σας!",
  "THIS_FIELD_HAS_MAXIMUM_ALLOWED_LENGTH_0_CHARACTERS": "Αυτό το πεδίο έχει μέγιστο επιτρεπτό μήκος {0} χαρακτήρες.",
  "THIS_FOLDER_IS_EMPTY": "Αυτός ο φάκελος είναι κενός.",
  "TIME": "Ώρα",
  "TIME_FIELDS_MUST_BE_IN_FORMAT_0": "Τα πεδία ώρας πρέπει να είναι στη μορφή {0}.",
  "UNABLE_TO_LOAD_ALL_FIELDS": "Αδυναμία φόρτωσης όλων των πεδίων:",
  "UNABLE_TO_RETRIEVE_REPOSITORY_INFORMATION": "Αδυναμία ανάκτησης πληροφοριών αποθετηρίου:",
  "UNKNOWN_ERROR": "Άγνωστο Σφάλμα.",
  "USER_NAME": "Όνομα Χρήστη",
  "YES": "Ναι"
}
